/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PriceSignal
 */
export interface PriceSignal {
    /**
     * 
     * @type {string}
     * @memberof PriceSignal
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof PriceSignal
     */
    value: number;
    /**
     * 
     * @type {number}
     * @memberof PriceSignal
     */
    weight: number;
    /**
     * 
     * @type {number}
     * @memberof PriceSignal
     */
    weightedScore: number;
}

/**
 * Check if a given object implements the PriceSignal interface.
 */
export function instanceOfPriceSignal(value: object): value is PriceSignal {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('weight' in value) || value['weight'] === undefined) return false;
    if (!('weightedScore' in value) || value['weightedScore'] === undefined) return false;
    return true;
}

export function PriceSignalFromJSON(json: any): PriceSignal {
    return PriceSignalFromJSONTyped(json, false);
}

export function PriceSignalFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceSignal {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
        'weight': json['weight'],
        'weightedScore': json['weighted_score'],
    };
}

export function PriceSignalToJSON(json: any): PriceSignal {
    return PriceSignalToJSONTyped(json, false);
}

export function PriceSignalToJSONTyped(value?: PriceSignal | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'value': value['value'],
        'weight': value['weight'],
        'weighted_score': value['weightedScore'],
    };
}

